import { Link, useParams } from "react-router-dom";
// import LinksDiff from "./LinksDiff";
import ReadOnlyFiles from "src/coursepart/ReadOnly/File/ReadOnlyFiles";
import { useI18n } from "src/utils/lni18n";
import LinksDiff from "./LinksDiff";
import ReadOnlyLinks from "src/coursepart/ReadOnly/Link/ReadOnlyLinks";
import { useMemo } from "react";
import { onePartatom } from "src/coursepart/CoursePartService";
import { useAtom } from "jotai";
import ChangedColorLegend, { ChangedColorLegendWrap } from "src/components/ChangedColorLegend";


const LinksDiffMain = () => {

    const { partId } = useParams();
    const { languageService: t } = useI18n();
    const partAtom = useMemo(() => onePartatom(partId!), [partId]);
    const [partData] = useAtom(partAtom);
    const linkDiffs = partData?.DiffLinks;

    if (!linkDiffs) return null;

    return (
        <>
            <div className="d-flex">
                <Link to={"../links"} className='ml-auto btn btn-inverse btn-small mb-4' >{`${t.getText("close")} ${t.getText("differences")}`}</Link>
            </div>


            <div className="row">

                <div className="col-md-6">
                    <ChangedColorLegend />
                    <h4 className="mb-2">{t.getText("edited")}</h4>
                    <LinksDiff linkGroups={linkDiffs.Edited} />
                </div>

                <div className="col-md-6">
                    <ChangedColorLegendWrap ></ChangedColorLegendWrap>
                    <h4 className="mb-2">{t.getText("published")}</h4>

                    <LinksDiff linkGroups={linkDiffs.Published} />
                </div>
            </div >
        </>
    )
}

export default LinksDiffMain;
